import React, { Component, type ReactElement } from 'react'
import type LeadershipDto from './LeadershipDto'
import socialIcon from '../../../images/company-board-x.svg'
import './style.css'

interface Props {
  leader: LeadershipDto
}

class LeadershipCard extends Component<Props> {
  render(): ReactElement {
    const { company, intro, name, position, profile, socialUrl } = this.props.leader

    return (
      <div className='leadershipCard'>
        <div className='leadershipCard-profile'>
          <img alt={name} src={profile} />
          <div className='leadershipCard-profileText'>
            <p>{name}</p>
          </div>
        </div>
        <div className='leadershipCard-body'>
          <div className='leadershipCard-title'>
            <p style={{ whiteSpace: 'pre-line' }}>{company}</p>
            <p>{position}</p>
          </div>
          <p className='leadershipCard-content'>{intro}</p>
          {socialUrl && (
            <div className='leadershipCard-social'>
              <a href={socialUrl} target='_blank' rel='noreferrer' aria-label={`${name} の X（新しいタブで開く）`}>
                <img src={socialIcon} alt='' />
              </a>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default LeadershipCard
